import {FormArray, ValidationErrors, ValidatorFn} from '@angular/forms';
import {findDuplicatesWidthIndexes} from "@app/shared/utils";


export class UniqueValueArrayFormValidator {
    static createValidator(valueField: string): ValidatorFn {
        return (control: FormArray): ValidationErrors => {
            const values: string[] = control.controls.map(control => control.getRawValue()[valueField])
            const out = findDuplicatesWidthIndexes(values)
            const allIndexes = Object.values(out).reduce((previousValue, currentValue) => previousValue.concat(currentValue), [])
            return allIndexes.length ? {
                message: 'lta-errors.uniqueValue',
                errorIndexes: allIndexes
            } : null;
        };
    }
}



